'use client';
import * as Tooltip from '@radix-ui/react-tooltip';
import { CertifiedPublisher as PublisherIcon } from 'phosphor-icons';
import { c } from '../../utils/tailwind-merge';
import { RichText } from '../RichText/RichText';
import { CertifiedPublisherProps } from './types';

export const CertifiedPublisher = ({
  microcopy: { description = '', icon = '' },
  className = '',
}: CertifiedPublisherProps) => {
  return (
    <div className={c(className)}>
      <Tooltip.Provider>
        <Tooltip.Root delayDuration={0}>
          <Tooltip.Trigger asChild>
            <button className="IconButton" aria-label={icon}>
              <PublisherIcon />
            </button>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              className="TooltipContent"
              sideOffset={5}
              side="bottom"
            >
              <div className="max-w-xs rounded bg-white p-4 shadow-card">
                <div className="px-3 pb-0">
                  <div className="flex items-start">
                    <RichText
                      html={description}
                      className="text-gray-400 text-sm"
                    />
                  </div>
                </div>
              </div>
              <Tooltip.Arrow width={14} height={8} style={{ fill: 'white' }} />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    </div>
  );
};
